import { EMIMETypes } from '@enums/common';
import { EDropzoneFileErrorCodes } from '@enums/dropzone';

import { MEGA_BYTE } from '@constants/common';

export const deleteTypeTooltipText = 'Delete asset type';
export const deleteSubTypeTooltipText = 'Delete asset subtype';

export const addTooltipText = 'Add Type';
export const addSubtypeTooltipText = 'Add subtype';
export const editTypeTooltipText = 'Edit asset type';
export const editSubTypeTooltipText = 'Edit asset subtype';

export const emptyTableText = 'No asset types available';
export const searchTooltipText = 'Search by asset type/subtype';
export const manageAssetTypesTitle = 'Manage Asset Types';

export const addAssetTypeModalTitle = 'Add new asset type';
export const editAssetTypeModalTitle = 'Edit asset type';

export const addAssetSubTypeModalTitle = 'Add new asset subtype';
export const editAssetSubTypeModalTitle = 'Edit asset subtype';

export const deleteAssetTypeModalQuestion = 'Are you sure you want to delete the asset type?';
export const deleteAssetSubTypeModalQuestion = 'Are you sure you want to delete the asset subtype?';

export const assetTypeInputName = 'assetTypeName';
export const assetTypeInputPlaceholder = 'Enter asset type name';
export const assetTypeInputLabel = 'Asset Type Name';
export const assetSubTypeInputName = 'assetSubTypeName';

export const assetSubTypeInputPlaceholder = 'Enter asset subtype name';
export const assetSubTypeInputLabel = 'Asset Subtype Name';

export const modalWidth = '580px';
export const deleteModalWidth = '480px';
export const ASSET_ICON_MAX_SIZE = 75;
export const ASSET_ICON_MAX_BYTES = 20 * MEGA_BYTE;

export const acceptedFileTypes = {
	[EMIMETypes.png]: ['.png'],
};

export const supportsText = `Recommended:
	Supported format: PNG
	The aspect ratio must be 1:1
	The dimensions should be maximum 75x75 px
`;

export const fileErrors = {
	[EDropzoneFileErrorCodes.fileInvalidType]: 'Allowed extension is PNG',
	[EDropzoneFileErrorCodes.tooManyFiles]: 'Only one file can be uploaded',
};
